module.exports = __webpack_public_path__ + "static/media/is-cheese.f420b109.png";